<template>
  <div id="help" :data-active="open" @click="checkShadowClick">
    <div class="modal">
      <div class="modal-header">
        <div class="modal-title">
          Ajuda
        </div>
        <div class="modal-close" @click="open = false">
          <img :src="CircleX" alt="fechar" width="32" height="32" />
        </div>
      </div>
      <div class="modal-subtitle">
        Aprenda como utilizar o trilhas de modo eficiente.
      </div>
      <div class="modal-content">
        <h2>Para encontrar o seu cargo:</h2>
        <p>Navegue pelos pontos ou faça uma busca no canto superior direito.</p>
        <h2>Navegação:</h2>
        <p>Escolha uma diretoria e visualize os cargos por meio das classificações:</p>
        <p class="blue">Azul - Posições estratégicas.</p>
        <p class="green">Vermelho - Posições táticas.</p>
        <p class="red">Verde - Posições operacionais.</p>
        <h2>Visualizações:</h2>
        <p>Você também pode filtrar uma sub área e desbloquear 3 modelos de visualização.</p>
      </div>
    </div>
  </div>
</template>

<script>
  import CircleX from 'Assets/images/circle-x.svg';
  import EventSystem from '../utils/EventSystem';

  export default {
    components: {
    },
    // Vars
    props: {},
    data() {
      return {
        CircleX,
        open: false,
      };
    },

    // Lifecyle
    created() {
      EventSystem.$on('keypress-esc', () => {
        this.open = false;
      });

      EventSystem.$on('help-open', () => {
        this.open = true;
      });
    },

    // Methods
    computed: {},
    methods: {
      checkShadowClick(evt) {
        try {
          if (evt.target.getAttribute('id') === 'help') {
            this.open = false;
          }
        } catch(_) {}
      }
    },
  };
</script>





// WEBPACK FOOTER //
// assets/js/source/vue-ui/help.vue